import React from 'react';

const SvgAccessible: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path
      fill="#5A636B"
      d="M7.5 3.2a1.5 1.5 0 0 1-1.11-.47A1.555 1.555 0 0 1 5.93 1.6c0-.44.153-.817.461-1.13A1.5 1.5 0 0 1 7.5 0a1.5 1.5 0 0 1 1.11.47c.308.313.461.69.461 1.13 0 .44-.153.817-.461 1.13a1.5 1.5 0 0 1-1.11.47ZM11.429 16v-4H7.5a1.5 1.5 0 0 1-1.11-.47 1.555 1.555 0 0 1-.461-1.13V5.6c0-.44.153-.817.461-1.13A1.5 1.5 0 0 1 7.5 4c.314 0 .586.07.815.21.23.14.475.363.737.67.72.88 1.372 1.483 1.954 1.81.583.327 1.248.497 1.994.51v1.6a5.252 5.252 0 0 1-2.102-.46 7.454 7.454 0 0 1-1.827-1.1V10h2.358a1.5 1.5 0 0 1 1.11.47c.307.313.461.69.461 1.13V16h-1.571Zm-5.5 0c-1.087 0-2.014-.39-2.78-1.17C2.383 14.05 2 13.107 2 12c0-.96.298-1.807.894-2.54.596-.733 1.345-1.193 2.249-1.38v1.64a2.566 2.566 0 0 0-1.13.89A2.31 2.31 0 0 0 3.571 12c0 .667.23 1.233.688 1.7.458.467 1.015.7 1.67.7.51 0 .965-.15 1.365-.45.4-.3.69-.683.874-1.15h1.61a3.914 3.914 0 0 1-1.355 2.29c-.72.607-1.552.91-2.494.91Z" // eslint-disable-line max-len
    />
  </svg>
);

export default SvgAccessible;
